// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"_1lm2O","icon":"_2FQtS","description":"JiAdh","call-to-action":"_14DFK","callToAction":"_14DFK"};
    if(module.hot) {
      // 1618742572143
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  